import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { LeftOutlined, RightOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Result, Spin, Tag, Typography } from 'antd';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import dayjs from 'dayjs';
import api from './api';
import '../../style/blog.css';

export default function BlogPostPage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const tag = searchParams.get('tag') || undefined;
  const listLink = tag ? `/blog?tag=${encodeURIComponent(tag)}` : '/blog';
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/posts/${slug}`, { params: { tag } })
      .then((res) => setPost(res.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug, tag]);

  if (loading) {
    return (
      <div className="blog-page" style={{ textAlign: 'center' }}>
        <Spin />
      </div>
    );
  }

  if (notFound || !post) {
    return (
      <div className="blog-page">
        <Result status="404" title="글을 찾을 수 없어요" />
      </div>
    );
  }

  const navLink = (navPost) => (tag ? `/blog/${navPost.slug}?tag=${encodeURIComponent(tag)}` : `/blog/${navPost.slug}`);

  return (
    <article className="blog-page">
      <Link to={listLink} className="blog-back-link">
        <UnorderedListOutlined /> 목록으로
      </Link>
      <Typography.Title level={2}>{post.title}</Typography.Title>
      <Typography.Text type="secondary">
        {post.published_at ? dayjs(post.published_at).format('YYYY.MM.DD') : ''}
      </Typography.Text>
      <div style={{ margin: '12px 0 24px' }}>
        {post.tags?.map((t) => (
          <Tag key={t}>{t}</Tag>
        ))}
      </div>
      <div className="blog-post-content">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.content}</ReactMarkdown>
      </div>
      <nav className="blog-post-nav">
        {post.previous ? (
          <Link to={navLink(post.previous)} className="blog-post-nav-item blog-post-nav-prev">
            <span className="blog-post-nav-label"><LeftOutlined /> 이전글</span>
            <span className="blog-post-nav-title">{post.previous.title}</span>
          </Link>
        ) : <span className="blog-post-nav-item blog-post-nav-empty" />}
        {post.next ? (
          <Link to={navLink(post.next)} className="blog-post-nav-item blog-post-nav-next">
            <span className="blog-post-nav-label">다음글 <RightOutlined /></span>
            <span className="blog-post-nav-title">{post.next.title}</span>
          </Link>
        ) : <span className="blog-post-nav-item blog-post-nav-empty" />}
      </nav>
    </article>
  );
}
